import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaUser, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { useDispatch } from "react-redux";
import { loginUser } from "../../../redux/userSlice";
import { API_URL } from "../../utils/api";
import { useToast } from "../../../context/ToastContext";
import { Link, useNavigate } from "react-router-dom";
import SignUpModal from "../SignUpModal";

export default function LoginForm({ onSuccess, onHide }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [useMobile, setUseMobile] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const handleClose = onHide;
  const [formData, setFormData] = useState({
    userId: "",
    mobile: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validateForm = () => {
    const err = {};
    if (useMobile) {
      if (!formData.mobile) err.mobile = "Mobile required";
      else if (formData.mobile.length !== 10)
        err.mobile = "10 digit mobile required";
    } else {
      if (!formData.userId) err.userId = "User ID required";
    }

    if (!formData.password) err.password = "Password required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = useMobile
      ? { mobile: formData.mobile, password: formData.password }
      : { userId: formData.userId, password: formData.password };

    const res = await dispatch(loginUser(payload));

    if (loginUser.fulfilled.match(res)) {
      showToast("Login successful 🎉", "success");
      onSuccess ? onSuccess() : navigate("/");
    } else {
      showToast(res.payload || "Login failed", "danger");
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/users/auth/google`;
  };

  return (
    <>
      <div className="text-center d-flex gap-2 align-items-center mb-2">
        <h4 className="text-white fw-bold">Login to</h4>
        <h4 className="text-orange fw-bold">Ambe Worlds</h4>
      </div>

      <div className="auth-tabs">
        <button
          className={`auth-tab ${!useMobile ? "active" : ""}`}
          onClick={() => setUseMobile(false)}
        >
          <FaUser /> User ID
        </button>
        <button
          className={`auth-tab ${useMobile ? "active" : ""}`}
          onClick={() => setUseMobile(true)}
        >
          <FaMobileAlt /> Mobile
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
        {useMobile ? (
          <Form.Group className="mb-3">
            <Form.Label>Mobile</Form.Label>
            <InputGroup>
              <InputGroup.Text>+91</InputGroup.Text>
              <Form.Control
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                isInvalid={!!errors.mobile}
              />
            </InputGroup>
          </Form.Group>
        ) : (
          <Form.Group className="mb-3">
            <Form.Label>User ID</Form.Label>
            <Form.Control
              name="userId"
              value={formData.userId}
              onChange={handleChange}
              isInvalid={!!errors.userId}
            />
          </Form.Group>
        )}

        <Form.Group className="mb-2">
          <Form.Label>Password</Form.Label>
          <InputGroup>
            <Form.Control
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              isInvalid={!!errors.password}
            />
            <Button
              variant="outline-secondary"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </Button>
          </InputGroup>
        </Form.Group>

        <Button type="submit" className="w-100 sign-btn">
          Sign In
        </Button>
      </Form>
      <div className="text-end m-2 align-item-left">
        <Link
          to="/user-reset-pass"
          className="forgot-link"
          onClick={() => {
            // handleClose();
            // setShowSignUp(true);
          }}
        >
          Forgot Password?
        </Link>
      </div>
      <div className="divider-container">OR</div>

      <button className="google-btn" onClick={handleGoogleLogin}>
        <FcGoogle /> Sign in with Google
      </button>

      <div className="text-center mt-3">
        New User?{" "}
        <span
          className="text-warning fw-bold cursor-pointer"
          onClick={() => {
            handleClose();
            setShowSignUp(true);
          }}
        >
          Create an account
        </span>
      </div>
      <SignUpModal show={showSignUp} handleClose={() => setShowSignUp(false)} />
    </>
  );
}
